import useSplitTreatment from 'hooks/useSplitTreatment';
import { SplitIO } from 'types';
import { qffAuthInit } from 'lib/qffAuth';
import { getAuthMethod } from 'store/authentication/selectors';
import { AuthMethod } from 'config/constants';
import { FC, useEffect } from 'react';
import { subscribeToQffEvents } from 'store/authentication/sso';
import { useSelector } from 'react-redux';

import { Dispatch } from 'redux';

interface QFFWidgetSubscriberProps {
  store: {
    dispatch: Dispatch;
  };
}

const QFFWidgetSubscriber: FC<QFFWidgetSubscriberProps> = ({ store }) => {
  const { isReady, split } = useSplitTreatment(SplitIO.Split.SELF_SERVICE_OAUTH, SplitIO.Treatment.ON);

  const authMethod = useSelector(getAuthMethod);

  useEffect(() => {
    // When OAuth is enabled, skip
    // When authMethod is not widget, skip
    if (authMethod !== AuthMethod.WIDGET || !isReady || split) {
      return;
    }

    // initialize QFF widget
    qffAuthInit();
  }, [authMethod, isReady, split]);

  useEffect(() => {
    // When OAuth is enabled, skip
    if (!isReady || split) {
      return;
    }

    // subscribe to QFF widget events
    subscribeToQffEvents(store.dispatch);
  }, [isReady, split, store]);

  return null;
};

export default QFFWidgetSubscriber;
